




















import {Component, Vue} from "vue-property-decorator";
import DashboardTemplate from "@/views/Layouts/dashboard-template.vue";
import List from "@/components/list.vue";
import Document from "@/models/document.model";
import DocumentService from "@/services/document.service";

@Component({
  components: {
    DashboardTemplate,
    List,
  },
})

export default class Documents extends Vue {
  private documents: Document[] = [];

  private async handleDownload(fileName: string) {
    const response = await DocumentService.GetDocumentByName(fileName);
    if (response && response.fileData) {
      const blob = new Blob([response.fileData], {type: response.contentType});
      const url = window.URL.createObjectURL(blob);

      window.open(url);
    }
  }
  private async mounted() {
    this.documents = await DocumentService.getAllDocuments();
  }
}
